import { useState } from 'react';

/**
 * Custom hook for managing interest rate
 * Handles interest rate state and validation
 *
 * @param {number} initialRate - Initial interest rate (default: 6.42)
 * @returns {Object} State value and handler
 */
const useInterestRate = (initialRate = 6.42) => {
  const [interestRate, setInterestRate] = useState(initialRate);

  /**
   * Handle interest rate changes
   * Validates and caps at 100%
   */
  const handleInterestRateChange = (value) => {
    const numValue = parseFloat(value) || 0;
    setInterestRate(Math.min(100, numValue));
  };

  return {
    interestRate,
    handleInterestRateChange,
    setInterestRate
  };
};

export default useInterestRate;
